import { render, staticRenderFns } from "./whBoAuto.vue?vue&type=template&id=2acdf195&scoped=true&"
import script from "./whBoAuto.vue?vue&type=script&lang=js&"
export * from "./whBoAuto.vue?vue&type=script&lang=js&"
import style0 from "./whBoAuto.vue?vue&type=style&index=0&id=2acdf195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdf195",
  null
  
)

export default component.exports